export default __webpack_public_path__ + "static/media/october.9816a36c.jpg";